import { render, staticRenderFns } from "./material_index.vue?vue&type=template&id=83b53ae4&scoped=true"
import script from "./material_index.vue?vue&type=script&lang=js"
export * from "./material_index.vue?vue&type=script&lang=js"
import style0 from "./material_index.vue?vue&type=style&index=0&id=83b53ae4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83b53ae4",
  null
  
)

export default component.exports